import React from 'react'
import Navbar from '../Navbar'
import { Helmet } from 'react-helmet-async'
import './Policies.css'

export const TermsConditions = () => {

    function handleClick() {
        document.getElementById('anchorHome').click()
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/terms-conditions" />
            </Helmet>
            <section className='hero policies '>
                <div className="container">
                    <div className=' hh2 ' data-aos="fade-up" data-aos-delay="200">
                        <span className="">Terms & Conditions</span>
                    </div>
                </div>
            </section>
            <section className="policies" data-aos="fade-up" data-aos-delay="300">
                <div className="container">
                    <div className="topic">
                        <div className="heading">1. Introduction</div>
                        <div className="content" >
                            <p>Welcome to <strong>Robustik</strong> ("Robustik," "we," "our," or "us").</p>
                            <p>These Terms & Conditions ("Terms") govern your access to and use of our Website, products, services, proposals, quotations, software, designs, branding materials, and all other services provided by Robustik.</p>
                            <p>By accessing our Website, requesting a quotation, purchasing any service, or otherwise engaging with our business, you acknowledge that you have read, understood, and agreed to be legally bound by these Terms.</p>
                            <p>If you do not agree with these Terms, you must discontinue using our Website and Services.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">2. Scope</div>
                        <div className="content">
                            <p>These Terms apply to all Services offered by Robustik, including but not limited to:</p>
                            <ul>
                                <li>Website Design.</li>
                                <li>Website Development.</li>
                                <li>E-commerce Development.</li>
                                <li>UI/UX Design.</li>
                                <li>Logo Design.</li>
                                <li>Branding.</li>
                                <li>Graphic Design.</li>
                                <li>Social Media Marketing.</li>
                                <li>Search Engine Optimization (SEO).</li>
                                <li>Website Maintenance.</li>
                                <li>Hosting Services.</li>
                                <li>Software Development.</li>
                                <li>SaaS Products.</li>
                                <li>API Integrations.</li>
                                <li>Technical Consulting.</li>
                                <li>Digital Strategy.</li>
                                <li>Future services introduced by Robustik.</li>
                            </ul>
                            <p>Separate agreements, including but not limited to a Master Service Agreement (MSA), Statement of Work (SOW), Proposal, Quotation, Invoice, or Change Request, shall prevail over these Terms where expressly stated.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">3. Definitions</div>
                        <div className="content" >
                            <p>For the purposes of these Terms:</p>
                            <p><strong className="text-white">"Company"</strong> means Robustik LLC (or Robustik during the pre-registration phase).</p>
                            <p><strong className="text-white">"Client"</strong> means any individual, business, organization, or entity requesting or purchasing our Services.</p>
                            <p><strong className="text-white">"Website"</strong> means all websites, landing pages, portals, applications, and digital properties operated by Robustik.</p>
                            <p><strong className="text-white">"Services"</strong> means all digital products and professional services offered by Robustik.</p>
                            <p><strong className="text-white">"Deliverables"</strong> means any work product delivered to the Client, including but not limited to designs, source code, graphics, documentation, reports, branding assets, software, or other agreed outputs.</p>
                            <p><strong className="text-white">"Project"</strong> means the specific engagement between Robustik and the Client.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4. Acceptance of Terms</div>
                        <div className="content" >
                            <p>By requesting our Services or using our Website, the Client confirms that:</p>
                            <ul>
                                <li>They are at least 18 years of age or otherwise legally capable of entering into binding agreements.</li>
                                <li>They have the authority to act on behalf of any business or organization they represent.</li>
                                <li>All information provided to Robustik is accurate and complete.</li>
                                <li>They agree to comply with these Terms and all applicable laws.</li>
                            </ul>
                            <p>Providing false, misleading, or fraudulent information may result in suspension or termination of Services.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5. Quotations, Proposals & Project Acceptance</div>
                        <div className="content" >
                            <p>All quotations, estimates, and proposals provided by Robustik are non-binding unless expressly stated otherwise</p>
                            <p>Unless otherwise specified, quotations are valid for <strong>30 calendar days</strong> from the date of issue.</p>
                            <p>A Project shall be considered accepted only when one or more of the following occurs:</p>
                            <ul>
                                <li>The Client provides written approval.</li>
                                <li>The Client pays the required advance payment.</li>
                                <li>The Client requests work to commence.</li>
                                <li>A signed agreement is received.</li>
                                <li>The Client otherwise authorizes Robustik to begin work.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">6. Payment Terms</div>
                        <div className="content" >
                            <p>Unless otherwise agreed in writing, Projects are subject to the following payment structure:</p>
                            <ul>
                                <li>Initial consultation: <strong className="text-white">Free.</strong></li>
                                <li>Initial concept(s): <strong className="text-white">Free of charge.</strong></li>
                                <li>Project commencement: <strong className="text-white">50% advance payment.</strong></li>
                                <li>Remaining balance: <strong className="text-white">Due before final delivery of source files, source code, administrative credentials, or ownership transfer.</strong></li>
                            </ul>
                            <p>Robustik reserves the right to suspend or delay work if any payment becomes overdue.</p>
                            <p>All invoices shall be payable in the currency specified on the invoice.</p>
                            <p>The Client shall be responsible for any bank charges, currency conversion fees, payment gateway fees imposed by their financial institution, taxes, duties, or governmental charges unless otherwise agreed.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7. Temporary Payment Processing</div>
                        <div className="content" >
                            <p>During our business setup phase, payments may be processed through an authorized billing partner.</p>
                            <p>Where applicable:</p>
                            <ul>
                                <li>Clients will receive clear payment instructions before making payment.</li>
                                <li>This temporary payment arrangement does not alter the contractual relationship between the Client and Robustik regarding the Services being provided.</li>
                                <li>Payment processing providers or authorized billing partners process payments in accordance with their own applicable policies and regulatory obligations.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">8. Project Scope</div>
                        <div className="content" >
                            <p>The approved proposal, quotation, Statement of Work (SOW), or written agreement defines the Project Scope.</p>
                            <p>Any request outside the agreed Scope shall be treated as a Change Request.</p>
                            <p>3 Robustik is not obligated to perform work outside the approved Scope without mutual written agreement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9. Fair Revision Policy</div>
                        <div className="content" >
                            <p>Robustik strives to provide an efficient and collaborative review process.</p>
                            <p>Unless otherwise specified in writing, revisions are provided under our Fair Revision Policy.</p>
                            <p>This means:</p>
                            <ul>
                                <li>Revisions apply only to the originally approved scope.</li>
                                <li>Revision requests should be submitted in consolidated feedback whenever reasonably possible.</li>
                                <li>Revisions must not introduce entirely new concepts, features, or functionality.</li>
                                <li>Requests that materially alter the approved scope shall be treated as Change Requests.</li>
                            </ul>
                            <p>Where a package advertises <strong>"Unlimited Revisions"</strong>, such revisions remain subject to this Fair Revision Policy and must be reasonable in nature.</p>
                            <p>Robustik reserves the right to decline excessive, abusive, repetitive, or unreasonable revision requests.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">10. Client Responsibilities</div>
                        <div className="content" >
                            <p>The Client agrees to:</p>
                            <ul>
                                <li>Provide accurate information.</li>
                                <li>Supply required content, images, logos, and other project materials unless otherwise agreed.</li>
                                <li>Review deliverables within the agreed timeframe.</li>
                                <li>Provide clear and timely feedback.</li>
                                <li>Maintain communication throughout the Project.</li>
                                <li>Obtain all necessary rights, licenses, and permissions for materials supplied to Robustik.</li>
                            </ul>
                            <p>The Client remains solely responsible for the legality and ownership of all materials supplied to Robustik.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">11. Client Response Time</div>
                        <div className="content" >
                            <p>Unless otherwise agreed in writing:</p>
                            <ul>
                                <li>The Client should provide requested approvals or feedback within <strong>7 business days</strong>.</li>
                            </ul>
                            <p>Failure to respond within this period may:</p>
                            <ul>
                                <li>Extend the Project timeline.</li>
                                <li>Delay scheduled delivery dates.</li>
                                <li>Require rescheduling based upon team availability.</li>
                            </ul>
                            <p>Where Client delays significantly affect the Project, Robustik reserves the right to revise project timelines and, where reasonably justified, propose additional charges associated with extended project management or resource allocation.</p>
                            <p>If a Project remains inactive for <strong>30 consecutive days</strong> due to Client inactivity, Robustik may place the Project on hold.</p>
                            <p>A reasonable <strong>Project Reactivation Fee</strong> may apply before work resumes. Such fee shall depend upon Project complexity, elapsed time, required re-planning, and resource availability.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">12. Project Cancellation</div>
                        <div className="content">
                            <p>The Client may request cancellation of a Project at any time by providing written notice.</p>
                            <p>The initial 50% advance payment is non-refundable once Project work has commenced.</p>
                            <p>If the Client cancels the Project after development or production has started, Robustik shall be entitled to payment for all work completed up to the date of cancellation.</p>
                            <p>Unless otherwise agreed in writing:</p>
                            <ul>
                                <li>Partially completed source code, design files, artwork, documentation, or other work products shall remain the property of Robustik until all applicable fees relating to those Deliverables have been paid in full.</li>
                                <li>Robustik is under no obligation to deliver partially completed work where outstanding amounts remain unpaid.</li>
                            </ul>
                            <p>Where the Client requests delivery of partially completed work following cancellation, Robustik may, at its sole discretion, provide such Deliverables upon payment of the applicable outstanding fees.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">13. Intellectual Property & Ownership</div>
                        <div className="content" >
                            <p>All concepts, drafts, mock-ups, prototypes, working files, development environments, internal documentation, and other preliminary materials remain the exclusive property of Robustik until full payment has been received.</p>
                            <p>Ownership of the final approved Deliverables transfers to the Client only after:</p>
                            <ul>
                                <li>Full payment has been received.</li>
                                <li>Any outstanding contractual obligations have been fulfilled.</li>
                            </ul>
                            <p>Robustik retains ownership of:</p>
                            <ul>
                                <li>Internal development tools.</li>
                                <li>Frameworks.</li>
                                <li>Libraries.</li>
                                <li>Reusable components.</li>
                                <li>Proprietary methodologies.</li>
                                <li>Templates.</li>
                                <li>Automation systems.</li>
                                <li>Pre-existing intellectual property.</li>
                            </ul>
                            <p>unless expressly transferred through a separate written agreement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">14. Source Code Delivery</div>
                        <div className="content" >
                            <p>Source code shall be delivered only after:</p>
                            <ul>
                                <li>The Project has been approved.</li>
                                <li>Full payment has been received.</li>
                                <li>All contractual obligations have been satisfied.</li>
                            </ul>
                            <p>Robustik is not obligated to release source code for cancelled, suspended, disputed, or unpaid Projects.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">15. Complimentary Hosting</div>
                        <div className="content" >
                            <p>Where specifically included in the purchased package, Robustik may provide <strong>one (1) year of complimentary basic shared hosting</strong>.</p>
                            <p>Complimentary hosting begins <strong>only after</strong>:</p>
                            <ul>
                                <li>Full payment has been received.</li>
                                <li>The Project has been completed and formally closed.</li>
                            </ul>
                            <p>Complimentary hosting is provided as a promotional benefit and does not form part of the purchased development service.</p>
                            <p>Complimentary hosting does not include, unless expressly agreed:</p>
                            <ul>
                                <li>Website migration.</li>
                                <li>Backup management.</li>
                                <li>Disaster recovery.</li>
                                <li>Advanced server administration.</li>
                                <li>Dedicated resources.</li>
                                <li>High-availability infrastructure.</li>
                                <li>Custom server configuration.</li>
                                <li>Email hosting.</li>
                                <li>Ongoing maintenance.</li>
                            </ul>
                            <p>Upon expiration of the complimentary hosting period, the Client may:</p>
                            <ul>
                                <li>Renew hosting through Robustik at the then-current pricing.</li>
                                <li>Migrate the Website to another hosting provider.</li>
                            </ul>
                            <p>Migration services, if requested, may be charged separately.</p>
                            <p>Complimentary hosting may be provided through Robustik's selected hosting infrastructure or trusted third-party hosting providers. Robustik reserves the right to determine, change, or migrate the underlying hosting provider where reasonably necessary to maintain service quality, security, operational efficiency, or business continuity</p>
                            <p>Complimentary hosting is subject to reasonable and fair usage. Robustik reserves the right to suspend or terminate complimentary hosting where excessive resource usage, abusive activity, unlawful content, or security risks materially affect the hosting environment.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">16. Domain Registration & SSL</div>
                        <div className="content" >
                            <p>Domain registration is not included unless specifically stated in the applicable proposal or package.</p>
                            <p>Where offered, complimentary domain registration applies only to eligible standard (non-premium) domain names for the initial registration period.</p>
                            <p>Premium domains, aftermarket domains, auction domains, or specialty domains shall be charged separately.</p>
                            <p>Where included, a standard SSL certificate may be provided for the initial complimentary hosting period. Continued SSL services after that period may require renewal fees.</p>
                            <p>Robustik does not guarantee the availability of any requested domain name.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">17. Third-Party Software & Paid Licenses</div>
                        <div className="content" >
                            <p>Robustik may incorporate third-party software, themes, plugins, libraries, APIs, or other components where appropriate.</p>
                            <p>Unless otherwise stated:</p>
                            <ul>
                                <li>Standard tools required by Robustik to deliver the agreed Project are included.</li>
                                <li>Any premium plugin, premium theme, commercial API, software license, subscription, or third-party service specifically requested by the Client shall be purchased at the Client's expense.</li>
                            </ul>
                            <p>The Client agrees to comply with all applicable third-party license terms.</p>
                            <p>Robustik shall not be responsible for changes, discontinuation, pricing adjustments, licensing modifications, feature limitations, outages, or policy changes introduced by third-party software providers.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">18. Artificial Intelligence (AI)</div>
                        <div className="content" >
                            <p>Robustik may use artificial intelligence tools to improve efficiency during the creation of Deliverables, including but not limited to:</p>
                            <ul>
                                <li>Content drafting.</li>
                                <li>Copywriting.</li>
                                <li>Graphic ideation.</li>
                                <li>Image generation.</li>
                                <li>Code assistance.</li>
                                <li>Research.</li>
                                <li>Translation.</li>
                                <li>Documentation.</li>
                            </ul>
                            <p>AI-assisted work shall, where reasonably practicable, be reviewed by a human before delivery.</p>
                            <p>The Client remains responsible for reviewing and approving all final Deliverables before publication or implementation.</p>
                            <p>Artificial Intelligence tools are used solely to assist human creativity, productivity, and operational efficiency and shall not replace professional judgement.</p>
                            <p>Unless otherwise agreed in writing, the use of AI-assisted tools shall not reduce the fees payable for the Services</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">19. Client Content</div>
                        <div className="content" >
                            <p>Unless otherwise agreed, the Client is responsible for providing:</p>
                            <ul>
                                <li>Text content.</li>
                                <li>Images.</li>
                                <li>Videos.</li>
                                <li>Branding assets.</li>
                                <li>Logos.</li>
                                <li>Product information.</li>
                                <li>Legal notices.</li>
                                <li>Policies.</li>
                                <li>Other required materials.</li>
                            </ul>
                            <p>Where requested by the Client, Robustik may assist in generating draft content using AI or other appropriate tools.</p>
                            <p>Final approval of all published content remains solely the responsibility of the Client.</p>
                            <p>Robustik is not responsible for inaccuracies, legal compliance, copyright issues, or claims arising from Client-approved content.</p>
                            <p>The Client represents and warrants that all supplied content complies with applicable laws and does not infringe any intellectual property, privacy, publicity, contractual, or other third-party rights.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">20. Search Engine Optimization (SEO)</div>
                        <div className="content" >
                            <p>Unless expressly included in the applicable proposal, Search Engine Optimization (SEO) services are not included within standard Website Development services.</p>
                            <p>Robustik follows generally accepted technical SEO best practices during Website development where reasonably applicable, including but not limited to:</p>
                            <ul>
                                <li>Semantic HTML structure.</li>
                                <li>Responsive design.</li>
                                <li>Basic metadata implementation.</li>
                                <li>Search engine friendly URLs.</li>
                                <li>XML sitemap support (where applicable).</li>
                                <li>Robots.txt configuration (where applicable).</li>
                            </ul>
                            <p>Advanced SEO services, keyword research, backlink campaigns, content strategy, local SEO, technical SEO audits, and ongoing optimization are separate services and may incur additional charges.</p>
                            <p>Robustik does not guarantee:</p>
                            <ul>
                                <li>Search engine rankings.</li>
                                <li>Specific keyword positions.</li>
                                <li>Organic traffic levels.</li>
                                <li>Lead generation.</li>
                                <li>Revenue increases.</li>
                            </ul>
                            <p>as these depend upon numerous factors outside our control.</p>
                            <p>Search engine algorithms are controlled by third parties and may change without notice.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">21. Performance & Compatibility</div>
                        <div className="content" >
                            <p>Robustik develops Websites using generally accepted industry standards.</p>
                            <p>Unless otherwise agreed, Websites are intended to be compatible with the latest stable versions of commonly used browsers, including major desktop and mobile browsers.</p>
                            <p>Website performance may vary depending upon:</p>
                            <ul>
                                <li>Hosting environment.</li>
                                <li>Third-party services.</li>
                                <li>Internet connection.</li>
                                <li>Device capabilities.</li>
                                <li>Browser extensions.</li>
                                <li>External scripts.</li>
                                <li>Animations.</li>
                                <li>Visual effects.</li>
                                <li>Media assets.</li>
                            </ul>
                            <p>Where Clients prioritize visual effects, advanced animations, or third-party integrations, such features may affect performance scores reported by third-party testing tools.</p>
                            <p>Robustik does not guarantee any specific score on performance testing platforms.</p>
                            <p>Performance testing tools use independent methodologies, and reported scores may vary over time without any modification to the Website.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">22. Accessibility</div>
                        <div className="content" >
                            <p>Unless specifically included within the Project scope, compliance with accessibility standards, including but not limited to WCAG, ADA, or other jurisdiction-specific accessibility requirements, is not included.</p>
                            <p>Accessibility consulting, auditing, remediation, or certification may be provided as separate professional services.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">23. Email Services & SMTP</div>
                        <div className="content" >
                            <p>Email hosting and SMTP services are generally provided by the Client or the Client's chosen hosting provider unless otherwise agreed.</p>
                            <p>Robustik may assist with SMTP configuration where included within the agreed Project scope.</p>
                            <p>Robustik does not guarantee email deliverability, inbox placement, spam filtering results, or the ongoing availability of third-party email services.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">24. Website Security</div>
                        <div className="content" >
                            <p>Robustik implements reasonable security practices during development.</p>
                            <p>The Client remains responsible for:</p>
                            <ul>
                                <li>Maintaining secure passwords.</li>
                                <li>Protecting account credentials.</li>
                                <li>Managing user access.</li>
                                <li>Updating credentials after staff changes.</li>
                                <li>Maintaining account security.</li>
                            </ul>
                            <p>Robustik shall not be responsible for unauthorized access resulting from:</p>
                            <ul>
                                <li>Weak passwords.</li>
                                <li>Credential sharing.</li>
                                <li>Phishing attacks.</li>
                                <li>Malware on Client devices.</li>
                                <li>Compromised third-party services.</li>
                                <li>Client negligence.</li>
                            </ul>
                            <p>The Client is responsible for maintaining backups of their own content unless backup services are expressly included within the applicable agreement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">25. Bug Warranty</div>
                        <div className="content" >
                            <p>Robustik provides a 30-day Bug Warranty commencing from the Project Acceptance Date.</p>
                            <p>During this period, Robustik will use commercially reasonable efforts to correct reproducible software defects that cause the delivered functionality to materially deviate from the approved Project scope.</p>
                            <p>The Bug Warranty does not cover:</p>
                            <ul>
                                <li>New feature requests.</li>
                                <li>Scope changes.</li>
                                <li>Third-party software updates.</li>
                                <li>Hosting issues outside Robustik's control.</li>
                                <li>Browser updates released after delivery.</li>
                                <li>Client modifications.</li>
                                <li>Third-party modifications.</li>
                                <li>Security incidents caused by external factors.</li>
                                <li>Bug reports should be submitted in writing together with sufficient information to reproduce the reported issue.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">26. Maintenance</div>
                        <div className="content" >
                            <p>Unless expressly included within the applicable agreement, ongoing maintenance, software updates, plugin updates, content updates, server administration, backups, monitoring, and technical support are not included after Project completion.</p>
                            <p>Maintenance services may be purchased separately.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">27. Confidentiality</div>
                        <div className="content" >
                            <p>Robustik shall treat information identified by the Client as confidential with reasonable care.</p>
                            <p>The Client is responsible for clearly identifying any information, documents, source code, business processes, or materials that are confidential.</p>
                            <p>Robustik may require a separate Non-Disclosure Agreement (NDA) for projects involving highly sensitive information.</p>
                            <p>Confidentiality obligations survive termination of the Project for a reasonable period unless otherwise agreed in writing or required by law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">28. Limitation of Liability</div>
                        <div className="content" >
                            <p>To the maximum extent permitted by applicable law, Robustik shall not be liable for any indirect, incidental, consequential, special, exemplary, or punitive damages, including but not limited to:</p>
                            <ul>
                                <li>Loss of profits.</li>
                                <li>Loss of business opportunities.</li>
                                <li>Loss of revenue.</li>
                                <li>Data loss.</li>
                                <li>Business interruption.</li>
                                <li>Reputational damage.</li>
                            </ul>
                            <p>except where liability cannot legally be excluded.</p>
                            <p>To the maximum extent permitted by applicable law, Robustik's aggregate liability arising out of or relating to any Project shall not exceed the total amount actually paid by the Client for the specific Services giving rise to the claim.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">29. Force Majeure</div>
                        <div className="content" >
                            <p>Robustik shall not be liable for delays or failure to perform resulting from events beyond its reasonable control, including but not limited to:</p>
                            <ul>
                                <li>Natural disasters.</li>
                                <li>Internet outages.</li>
                                <li>Cyber attacks.</li>
                                <li>Government actions.</li>
                                <li>War.</li>
                                <li>Civil unrest.</li>
                                <li>Labor disputes.</li>
                                <li>Pandemics.</li>
                                <li>Utility failures.</li>
                            </ul>
                            <p>Project timelines shall be reasonably adjusted where such events occur.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">30. Governing Law & Dispute Resolution</div>
                        <div className="content" >
                            <div className="sub-heading">Governing Law</div>
                            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Wyoming, United States, without regard to its conflict of law principles, except where mandatory consumer protection laws of another jurisdiction apply.</p>

                            <div className="sub-heading">Good Faith Negotiation</div>
                            <p>In the event of any dispute, claim, or controversy arising out of or relating to these Terms or the Services provided by Robustik, the parties agree to first attempt to resolve the matter through good-faith negotiations.</p>

                            <div className="sub-heading">Mediation</div>
                            <p>If the dispute cannot be resolved through good-faith negotiations within a reasonable period, the parties may mutually agree to submit the dispute to mediation before commencing legal proceedings. Unless otherwise agreed, each party shall bear its own costs associated with the mediation process.</p>

                            <div className="sub-heading">Legal Proceedings</div>
                            <p>If the dispute remains unresolved following negotiations and, where applicable, mediation, either party may pursue any available legal remedies before a court of competent jurisdiction, subject to applicable law and the terms of any separate written agreement between the parties.</p>
                            <p>Nothing in this Section prevents either party from seeking urgent injunctive or equitable relief where such relief is necessary to protect its legal rights or intellectual property.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">31. Changes to These Terms</div>
                        <div className="content" >
                            <p>Robustik reserves the right to modify or update these Terms from time to time.</p>
                            <p>The most current version will be published on our Website together with the applicable revision date.</p>
                            <p>Continued use of our Website or Services after publication of revised Terms constitutes acceptance of the updated Terms to the extent permitted by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">32. Contact Information</div>
                        <div className="content" >
                            <p>For questions regarding these Terms, please contact:</p>
                            <p><strong className="text-white">Robustik</strong></p>
                            <p>Email: contact@robustik.com</p>
                            <p>Registered Business Address: To be updated upon company registration.</p>
                        </div>
                    </div>

                </div>
            </section>

        </>
    )
}
